module.exports = __webpack_public_path__ + "static/fonts/lato-semibold.c2b50f4.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lato-font/fonts/lato-semibold/lato-semibold.woff
// module id = DS6Y
// module chunks = 13